// src/helpers/api.js
import axios from "axios";

const API_BASE =
  process.env.REACT_APP_API_BASE || "https://backsanpancracio.us-3.evennode.com";

/* =========================
   Config global Axios
   ========================= */
axios.defaults.baseURL = API_BASE;
axios.defaults.withCredentials = false;

// Interceptor GLOBAL para token
axios.interceptors.request.use((config) => {
  const tk =
    localStorage.getItem("token") ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("jwt");

  if (tk) {
    config.headers.token = tk;                  // tu back lo usa
    config.headers.Authorization = `Bearer ${tk}`; // por si usás Bearer
  } else {
    delete config.headers.token;
    delete config.headers.Authorization;
  }

  if (!config.headers["Content-Type"] && config.method !== "get") {
    config.headers["Content-Type"] = "application/json";
  }

  return config;
});

/* =========================
   Instancia principal (default export)
   ========================= */
const api = axios.create({
  baseURL: API_BASE,
  withCredentials: false,
  timeout: 30000,
});

// Reusar el interceptor global en la instancia
api.interceptors.request.use((config) =>
  axios.interceptors.request.handlers[0].fulfilled(config)
);

/* =========================
   Helpers opcionales (named)
   ========================= */
async function apiGet(path, config = {}) {
  const res = await api.get(path, config);
  return res.data;
}

async function apiPost(path, body = {}, config = {}) {
  const res = await api.post(path, body, config);
  return res.data;
}

async function apiPut(path, body = {}, config = {}) {
  const res = await api.put(path, body, config);
  return res.data;
}

async function apiDelete(path, config = {}) {
  const res = await api.delete(path, config);
  return res.data;
}

const API_URL = API_BASE;

export default api;              // 👈 mantiene compatibilidad con tu código
export { axios, API_URL, apiGet, apiPost, apiPut, apiDelete };
